import {Vision} from '../message/Vision';
import {VisionScenario} from './VisionScenario';

export class VisionDuplicationScenario extends VisionScenario {
businessUnitCode: string;
duplicateBaselines: boolean | null;
duplicateCssRender: boolean | null;
duplicateFilterKeys: boolean | null;
duplicateIncExcKeys: boolean | null;
duplicateKeys: boolean | null;
duplicateMeasures: boolean | null;
duplicateProfiles: boolean | null;
duplicateRoles: boolean | null;
duplicateScenarios: boolean | null;
duplicateStepPerimeters: boolean | null;
duplicateSteps: boolean | null;
duplicateStyles: boolean | null;
duplicateTabs: boolean | null;
duplicateTemplates: boolean | null;
duplicateVision: boolean | null;
duplicateWorkCom: boolean | null;
originVisionKey: Vision;
}

